export enum RepertoireFiltersEnum {
    SCHOOL_YEAR = 'schoolYear',
    EDUCATION_LEVEL = 'educationLevel',
    ENTITY_TYPES = 'types',
}
